export default __webpack_public_path__ + "static/media/reports-empty.a9b95497.svg";